import React from 'react';
import { View, Link, Icon, colors } from '@fairygodboss/ui';
import PropTypes from 'prop-types';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';

const JobsBackLink = ({ job, company }) => {
    const linkText = 'JOB SEARCH';
    const { slug } = job;
    const { companyUrl } = company;

    const handleLinkClick = () => {
        EmitMetric({
            click: 1,
            misc_event_type: 'sjp-job-search-click',
            url: `/jobs/${companyUrl}/${slug}`,
            referrer: 'https://www.google.com/',
        });
    };

    return (
        <View
            display="flex"
            justifyContent="space-between"
            width="100%"
            backgroundColor="#fff"
            pt={{ _: '34px', sm: '34px', md: '34px' }}
        >
            <View
                css={{
                    'a:visited': {
                        color: `${colors.primary[60]} !important`,
                        textDecoration: 'none !important',
                        'div > svg': {
                            path: {
                                fill: colors.primary[60],
                            },
                        },
                        'a:hover': {
                            'div > svg': {
                                path: {
                                    fill: colors.primary[80],
                                },
                            },
                        },
                    },
                    'a:hover': {
                        opacity: '1 !important',
                        textDecoration: 'underline !important',
                    },
                    a: {
                        textDecoration: 'none !important',
                        fontSize: '16px',
                        lineHeight: '20px',
                        fontWeight: '600',
                    },
                    svg: {
                        height: '14px',
                    },
                }}
            >
                <Link
                    href="/jobs/find"
                    target="_self"
                    variant="inline"
                    onClick={handleLinkClick}
                >
                    <Icon height="14px" variant="chevron_left_16" />
                    {linkText}
                </Link>
            </View>
        </View>
    );
};

JobsBackLink.propTypes = {
    job: PropTypes.oneOf([PropTypes.object]).isRequired,
    company: PropTypes.oneOf([PropTypes.object]).isRequired,
};

export default JobsBackLink;
